// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vj-z","tupacHeader":"wj-z","tupacHeader2":"xj-z","tupacMenu":"yj-z","tupacMenu2":"zj-z","tupacMain":"Aj-z","tupacMain2":"Bj-z"};